/* Digital Archive v3 — Regal: scroll reveal (mirrors the-ai-collective.com Reveal primitive).
   Content is visible without JS; reveal only runs when IntersectionObserver exists and the visitor
   has not asked for reduced motion. 8s safety fallback shows everything. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  var SEL = '.cc-reveal, .product-grid__item, .resource-card, .archive-details, .whats-next, .cc-grid__head, .cc-build__head';
  var root = document.documentElement;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
  function arm(scope) {
    var vh = window.innerHeight || 800;
    (scope || document).querySelectorAll(SEL).forEach(function (el, i) {
      if (el.dataset.ccArmed) return;
      el.dataset.ccArmed = '1';
      el.classList.add('cc-reveal');
      if (el.getBoundingClientRect().top < vh) { el.classList.add('is-in'); return; }
      if (el.classList.contains('product-grid__item')) el.style.setProperty('--cc-delay', (i % 4) * 70 + 'ms');
      io.observe(el);
    });
  }
  function start() {
    root.classList.add('cc-js');
    arm(document);
    setTimeout(function () { document.querySelectorAll('.cc-reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 8000);
    /* Horizon re-renders the grid on filter/sort/pagination: arm new items */
    if ('MutationObserver' in window) {
      var main = document.getElementById('MainContent') || document.body;
      new MutationObserver(function () { arm(main); }).observe(main, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
